module.exports = __webpack_public_path__ + "img/xunzhang_icon_lanv@3x.dee98fbb.png";